import React, { FC, ReactNode } from "react";
import { Stack, Typography } from "@mui/material";
import { ContactLink } from "../ContactLink";

export const ContactLabel: FC<ContactLabelProps> = ({
  label,
  contact,
  socialLinks
}) => (
    <Stack alignItems="flex-start">
      <Typography
        component="span"
        sx={{
          color: theme => theme.palette.common.white,
          opacity: 0.7,
          fontSize: "1rem",
          lineHeight: 1.5,
          fontWeight: 400
        }}
      >
        {label}
      </Typography>
      {!!contact && <ContactLink {...contact} />}
      {!!socialLinks && (
        <Stack direction="row">
          {socialLinks.map((link, index) => (
            <ContactLink key={index} {...link} iconOnly />
          ))}
        </Stack>
      )}
    </Stack>
  );

interface ContactItem {
  label: string;
  href: string;
  icon?: ReactNode;
}

export interface ContactLabelProps {
  label: string;
  contact?: ContactItem;
  socialLinks?: Required<ContactItem>[];
}
